import { EnvelopeIcon } from "@heroicons/react/24/solid";
import type React from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { Base } from "@/atoms-react/text/Text.react";
import { AliasCard } from "../alias-card/index.react";
import { AliasMailSchema } from "@/types/user/alias-mail.types";

type EmailCardProps = {
  email: AliasMailSchema;
  isLoading?: boolean;
  onClick?: () => void;
  onPublicClick?: () => void;
  onDelete?: () => void;
  disabled?: boolean;
  dataCy?: string;
} & Omit<React.ComponentPropsWithoutRef<"div">, "onClick">;

export const EmailCard = ({ email, onPublicClick, disabled = false, ...props }: EmailCardProps) => {
  const { t } = useTranslation(["pass"]);
  return (
    <AliasCard
      tooltipDesignation={t("olkypass.aliasPublicPage.this_email")}
      icon={EnvelopeIcon}
      isPublic={email.public}
      onPublicClick={onPublicClick}
      disabled={disabled}
      dataCy={props?.dataCy}
      {...props}
    >
      <Base
        className={twMerge(
          "overflow-hidden text-ellipsis whitespace-nowrap break-normal font-semibold md:mr-3"
        )}
        title={email.mail}
      >
        {email.mail}
      </Base>
    </AliasCard>
  );
};
